// extracted by mini-css-extract-plugin
export default {"tooltip":"_1kew0","arrow":"_3tubW","content":"_3ppxp"};